import AutoScroll from "embla-carousel-auto-scroll";
import { Carousel } from "../../../ui/Carousel";
import { CarouselContent } from "../../../ui/Carousel";
import { CarouselItem } from "../../../ui/Carousel";
import { ReactNode } from "react";

export const CarouselSection = ({ items }: { items: ReactNode[] }) => {
  return (
    <Carousel
      opts={{
        align: "start",
        loop: true,
        slidesToScroll: 1,
        containScroll: "trimSnaps",
        dragFree: true,
        skipSnaps: false,
      }}
      plugins={[
        AutoScroll({
          playOnInit: true,
          stopOnInteraction: true,
          rootNode: (emblaRoot) => emblaRoot.parentElement,
          speed: 1,
        }),
      ]}
      className="tw-w-full tw-overflow-hidden"
    >
      <CarouselContent className="tw-ml-0 tw-flex tw-items-center tw-justify-start tw-gap-x-[.625em] tw-px-[.625em]">
        {items.map((item, idx) => (
          <CarouselItem
            key={idx}
            className="tw-flex tw-w-fit tw-items-center tw-justify-center !tw-pl-[0em]"
          >
            {item}
          </CarouselItem>
        ))}
      </CarouselContent>
    </Carousel>
  );
};
